import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';

// Self-hosted fonts (no runtime dependency on Google Fonts CDN)
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/600.css';

// Stylesheet order matters and is deliberate:
//   tokens → base → primitives → patterns   (the shared layers)
//   App                                     (pulls in each component's own CSS)
//   utilities                               (last, so a utility always wins)
// Moving the utilities import above App would let component classes override
// utilities like .mt-14 / .fs-13, which is not what the call sites expect.
import './styles/tokens.css';
import './styles/base.css';
import './styles/primitives.css';
import './styles/patterns.css';
import App from './App';
import './styles/utilities.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);
